<template>
    
    <b-row>
        <b-col cols='12' v-if="versionArrays">
                <app-collapse>

                    <app-collapse-item v-for="(el, index) in versionArrays" :key="index" title="سير المعاملة" :isVisible="islastVersion(index)">
                        <app-timeline>
                            <app-timeline-item
                                :variant="item.status == 'open'? 'success' : 'secondary' "
                                icon="ShoppingBagIcon"
                                v-for="(item , i) in el"
                                :key="i"
                            >
                            
                                <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                                <h5>  {{ item.actionType.description }}</h5>
                                <div class="d-flex align-items-baseline ml-auto">
                                    <p class="mx-2"><transactions-status-formatter :value="item.status"/></p>
                                    <b-button
                                        v-b-toggle="'report-list-with-icon-' + item.id"
                                        size="sm"
                                        variant="outline-primary"
                                        >
                                        عرض التفاصيل
                                    </b-button>
                                </div>
                                </div>
                    <b-collapse :id="`report-list-with-icon-${item.id}`">
                        <b-row class="mt-2">
                            <b-col cols="12" class="mb-1" v-if="item.notes">
                                <h5 for="login-password"> ملاحظات التعقيب </h5>
                                <hr />
                                <p>{{  item.notes  }}</p>
                            </b-col>
                            <b-col cols="12" class="mb-1" v-if="item.extra_data">
                                <h5 for="login-password"> بيانات إضافية </h5>
                                <hr />
                                <p>{{  item.extra_data  }}</p>
                            </b-col>
                           
                            <b-col cols="4">
                                
                                <h5 for="login-password">  مدة الإجراء  </h5>
                                <hr />
                                <app-timeline>
                                    <app-timeline-item
                                        variant="success"
                                    >
                                        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                                            <p>التاريخ اللازم لبدء الإجراء  : {{ item.start_date }}</p>
                                        </div>
                                    </app-timeline-item>
                                    <app-timeline-item
                                        variant="danger"
                                    >
                                        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                                            <p>التاريخ اللازم لإنهاء الإجراء  : {{ item.end_date }}</p>
                                        </div>
                                    </app-timeline-item>
                                </app-timeline>
                            </b-col>
                            <b-col cols="4" v-if="item.actionMinistryUserHistories.length > 0 && $router.currentRoute.path.includes('ministry') && !$router.currentRoute.path.includes('temp-ngo')">
                                
                                <h5 for="login-password">  الموظفين الذين قاموا بتنفيذ الإجراء </h5>
                                <hr />
                                <b-row v-for="user in item.actionMinistryUserHistories">
                                    <b-col cols="6">
                                        <b-media  class="my-1">
                                            <template #aside>
                                                <b-avatar src="" />
                                            </template>
                                            <p>{{ user.ministryUser.full_name  }} </p>
                                        </b-media>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="4" v-if="item.hasOwnProperty('actionHistoryDocs') && item.actionHistoryDocs.length>0">
                                <div v-if="!isNgo">

                                    <h5 for="login-password"> المُرفقات </h5>
                                   
                                    <hr />
                                    <b-list-group
                                    
                                    flush
                                    class="mt-1"
                                    >
                                    <b-list-group-item
                                        v-for="doc in item.actionHistoryDocs"
                                        href="#"
                                        class="d-flex justify-content-between align-items-center bg-transparent"
                                    >
                                        <span>{{doc.title}}</span>
                                        <feather-icon icon="EyeIcon" 
                                            @click="$router.push({ name: 'file-view', query: { ep: doc.file } })"
                                        />
    
                                    </b-list-group-item>
                                    </b-list-group>
                                </div>
                                <div v-else>
                                    <div v-if="el.length-1 == i">
                                        <h5 for="login-password"> المُرفقات </h5>    

                                        <hr />
                                        <b-list-group

                                        flush
                                        class="mt-1"
                                        >
                                        <b-list-group-item
                                            v-for="doc in item.actionHistoryDocs"
                                            href="#"
                                            class="d-flex justify-content-between align-items-center bg-transparent"
                                        >
                                            <span>{{doc.title}}</span>
                                            <feather-icon icon="EyeIcon" 
                                                @click="$router.push({ name: 'file-view', query: { ep: doc.file } })"
                                            />

                                        </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-collapse>
                    
                </app-timeline-item>
            </app-timeline>
                    </app-collapse-item>

                    
                </app-collapse>
            <hr />
        </b-col>
        
        <b-modal
            title="الصورة المُرفقة"
            size="lg"
            v-model="showImage"
            footer-class="removed"
            >
            <b-img
                style="height: 50%; width: 100%"
                :src="pathImage"
                rounded
                fluid
                alt="profile photo"
            />
        </b-modal>
    </b-row>
</template>

<script>
import {BAvatar , BMedia, BCol , BRow , VBToggle , VBTooltip , BButton, BCollapse , BListGroup, BListGroupItem , BTable , BModal , BImg , BCard} from "bootstrap-vue";
import InfoCard from "@/components/InfoCard.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import TransactionsStatusFormatter from "@/modules/ngo/transactions/components/TransactionsStatusFormatter.vue";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';

import router from "@/router";
import Alert from "@/components/Alert.vue";
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
export default {
    components: {
        BAvatar , BMedia ,BCol , InfoCard , BRow , BButton ,  AppTimeline, AppTimelineItem , BCollapse , BListGroup, BListGroupItem , TransactionsStatusFormatter , BTable , BModal , BImg , BCard , AppCollapse , AppCollapseItem , Alert
    },
    props: {
        actionHistories: Array  ,
        isNgo : Boolean
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
    data() {
      return {
        showImage : false ,
        // versionArrays : {} ,
        pathImage : '',
        fields: [
        { key: "id", label: "المعرف" },
        { key: "title", label: "عنوان المُرفق" },
        { key: "file", label: "" },
      ],
      }
    },
    // mounted() {
    //     // console.log("dfdfgdfg")
    //     // this.updateVisible()
    // },
    computed: {
        versionArrays() {
            let verArrays = {}
            // Iterate over actionHistories and populate versionArrays
            this.actionHistories.forEach(item => {
                    if (item.hasOwnProperty('version_number')) {
                        if (!verArrays[item.version_number]) {
                            verArrays[item.version_number] = [];
                        }
                        verArrays[item.version_number].push(item);
                    }
                });

                // Output the arrays based on version_number
                for (let versionNumber in verArrays) {
                    console.log(`Array with version_number = ${versionNumber}:`);
                    console.log(verArrays[versionNumber]);
                }
            return verArrays;
        },
    },
    methods: {
        islastVersion(index){
            if(index == 'null'){
                console.log("index" , index)

                return true
            }
            else{

                return false
            }
           
        }
    }
};
</script>